var React = require('react');

function Fintech (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.1429 9.42847H7.85721C6.12146 9.42847 4.71436 10.8356 4.71436 12.5713V31.4285C4.71436 33.1642 6.12146 34.5713 7.85721 34.5713H36.1429C37.8787 34.5713 39.2858 33.1642 39.2858 31.4285V12.5713C39.2858 10.8356 37.8787 9.42847 36.1429 9.42847Z","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4.71436 18.8572H39.2858","stroke":"#5B59FB","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Fintech.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Fintech;

Fintech.default = Fintech;
